import { useEffect, useState } from 'react';
import type { RevenueTransition } from '../types/finance';
import { getRevenueTransitions } from '../lib/api/endpoints';
import { revenueTransitionsFromDto } from '../lib/api/mappers';

/** FE-32 — la bitácora de un ingreso, bajo demanda (evita N+1). */
export function useRevenueTransitions(revenueId: string | null) {
  const [transitions, setTransitions] = useState<RevenueTransition[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!revenueId) {
      setTransitions([]);
      setError(null);
      return;
    }
    let cancelled = false;
    const load = async () => {
      setIsLoading(true);
      setTransitions([]);
      try {
        const res = await getRevenueTransitions(revenueId);
        if (cancelled) return;
        setTransitions(revenueTransitionsFromDto(res.items));
        setError(null);
      } catch (err) {
        if (!cancelled) setError(err instanceof Error ? err : new Error('Error desconocido cargando la bitácora'));
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };
    load();
    return () => { cancelled = true; };
  }, [revenueId]);

  return { transitions, isLoading, error };
}
